import { render, staticRenderFns } from "./SiteTabsList.vue?vue&type=template&id=55d12a0a&scoped=true&"
import script from "./SiteTabsList.vue?vue&type=script&lang=js&"
export * from "./SiteTabsList.vue?vue&type=script&lang=js&"
import style0 from "./SiteTabsList.vue?vue&type=style&index=0&id=55d12a0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d12a0a",
  null
  
)

export default component.exports